import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import { Link } from 'react-router-dom';
import { useIntl } from '@jetshop/intl';
import { StructuredBreadcrumbData } from '@jetshop/core/components/StructuredData/StructuredBreadcrumbData';
import useWarningInDev from '@jetshop/core/hooks/useWarningInDev';
const StyledBreadcrumbs = /*#__PURE__*/styled('ul')({
  name: "StyledBreadcrumbs",
  class: "s1trcchx"
});
const Breadcrumb = /*#__PURE__*/styled('li')({
  name: "Breadcrumb",
  class: "b1943hhp"
});
export default function Breadcrumbs(props) {
  const t = useIntl();
  const {
    breadcrumbs,
    breadcrumbText,
    parents,
    hideLast,
    className
  } = props;
  useWarningInDev(!breadcrumbs, 'Using <Breadcrumbs> without passing the breadcrumbs prop is deprecated.');

  if (breadcrumbs) {
    const crumbs = breadcrumbs.reduce((acc, text, index) => {
      const crumb = {
        text,
        path: null
      };

      if (index < (parents === null || parents === void 0 ? void 0 : parents.length)) {
        crumb.path = parents[parents.length - 1 - index].path;
      }

      return acc.concat(crumb);
    }, [{
      text: t('Home'),
      path: '/'
    }]);
    return React.createElement(React.Fragment, null, React.createElement(StructuredBreadcrumbData, {
      breadcrumbs: crumbs.slice(1)
    }), React.createElement(StyledBreadcrumbs, {
      className: cx(className, hideLast && 'hide-last')
    }, crumbs.map((crumb, index) => crumb.text && React.createElement(Breadcrumb, {
      key: index
    }, !crumb.path ? crumb.text : React.createElement(Link, {
      to: {
        pathname: crumb.path,
        state: {
          type: 'Category'
        }
      }
    }, crumb.text)))));
  } else {
    // This is deprecated, remove in next major
    if (breadcrumbText) {
      const crumbs = (parents || []).reduceRight((acc, parent) => {
        var _a;

        return [...acc, {
          text: (_a = parent.object) === null || _a === void 0 ? void 0 : _a.breadcrumbText,
          path: parent.path
        }];
      }, [{
        text: t('Home'),
        path: '/'
      }]);
      crumbs.push({
        text: breadcrumbText,
        path: null
      });
      return React.createElement(React.Fragment, null, React.createElement(StructuredBreadcrumbData, {
        parents: parents,
        breadcrumbText: breadcrumbText
      }), React.createElement(StyledBreadcrumbs, {
        className: cx(className, hideLast && 'hide-last')
      }, crumbs.map((crumb, index) => crumb.text && React.createElement(Breadcrumb, {
        key: index
      }, !crumb.path ? crumb.text : React.createElement(Link, {
        to: {
          pathname: crumb.path,
          state: {
            type: 'Category'
          }
        }
      }, crumb.text)))));
    } else {
      return null;
    }
  }
}

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Breadcrumbs/Breadcrumbs.linaria.css");